import styles from './Embed.style';
import Preview from './embed/Preview';
import PreviewEmbed from './embed/PreviewEmbed';

class Embed extends React.Component {
  render() {
    const { classes, form } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.lhc}>
          <Preview form={form} onChange={this.props.onChange} />
        </div>
        <div className={classes.rhc}>
          <PreviewEmbed form={form} />
        </div>

        <div className={classes.background} />
      </div>
    );
  }
}

Embed.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(Embed);
